// Pattern: docs/design-patterns/frontend/component-patterns.md (layout-structure-only)
// Pattern: docs/design-patterns/frontend/responsive-design.md
//
// Generic, responsive board frame: a flex container that stacks its columns
// vertically by default and lays them out in a row at the `lg` breakpoint.
// Props in, JSX out — no drag-and-drop, no data fetching, no store access;
// mirrors the existing board frame's layout classes
// (src/pages/Projects/Board/Board.tsx:234) without touching that file.
import type { JSX, ReactNode } from 'react';

export interface BoardProps {
  /** The board's columns (typically `BoardColumn` elements). */
  children: ReactNode;
  /** Additional class names appended to the frame's own layout classes. */
  className?: string;
}

/**
 * Generic board frame. See `BoardProps` for the contract.
 */
export function Board({ children, className = '' }: BoardProps): JSX.Element {
  return (
    <div className={`flex flex-col lg:flex-row gap-6 min-h-0 overflow-hidden ${className}`}>
      {children}
    </div>
  );
}
